(function(document) {
  /* Enable touchstart for mobile hover effects */
  function noop() {}
  document.body.addEventListener('touchstart', noop, false);

  /* Show comments in viewer's time zone */
  var commentMetas = document.getElementsByClassName('commentmetadata');
  [].forEach.call(commentMetas, function(commentMeta) {
    var dateLink = commentMeta.children[0];
    var dateStrings = dateLink.text.split(' at ');
    var dateString = dateStrings[0].trim();
    var timeString = dateStrings[1].trim();
    var commentDateInUTC = new Date(dateString + ' ' + timeString + window.commentGMTOffset);
    var localTimeZoneString = new Date()
      .toString()
      .match(/\(([^)]+)\)/)
      .pop();
    var abbrElement = document.createElement('ABBR');
    abbrElement.title = 'Time shown in ' + localTimeZoneString;
    var timeElement = document.createElement('TIME');
    timeElement.dateTime = commentDateInUTC.toISOString();
    var dateOnly = commentDateInUTC.toLocaleDateString();
    var timeOnly = commentDateInUTC.toLocaleTimeString();
    var commentWasToday = commentDateInUTC.toLocaleDateString() === new Date().toLocaleDateString();
    if (commentWasToday) {
      timeElement.innerText = timeOnly;
    } else {
      timeElement.innerText = dateOnly;
      abbrElement.title = '(' + timeOnly + ') ' + abbrElement.title;
    }
    abbrElement.appendChild(timeElement);
    dateLink.parentNode.replaceChild(abbrElement, dateLink);
  });

  /* Enable comment form auto-resizing */
  var comment = document.getElementById('comment');
  if (comment) {
    var lineHeight = parseInt(getComputedStyle(comment).lineHeight);
    function handleHeight() {
      comment.rows = 1;
      var padding = 16; /* 16px for top/bottom padding */
      var nextRows = Math.ceil((comment.scrollHeight - padding) / lineHeight);
      comment.rows = nextRows;
    }
    handleHeight();
    comment.addEventListener('change', handleHeight);
    comment.addEventListener('input', handleHeight);
  }

  /* Lazy image loading */
  function throttle(interval) {
    var lastCalledAt = +new Date() - interval;
    var timeout = null;
    var fn = this;
    return function() {
      var _this = this;
      var args = [].slice.call(arguments);
      var calledAt = +new Date();
      var callIn = interval - Math.min(interval, calledAt - lastCalledAt);
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        fn.apply(_this, args);
        lastCalledAt = calledAt;
      }, callIn);
    };
  }
  function isScrolledIntoView(element) {
    var rect = element.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    return elemTop < window.innerHeight && elemBottom >= 0;
  }
  function fadeInImageFromPlaceholder(imagePlaceholder) {
    var imageSrc = imagePlaceholder.getAttribute('data-src');
    var imageID = imagePlaceholder.getAttribute('id');
    var image = new Image();
    var startTime = new Date().getTime();
    var minimumTimeToLoad = 250;
    var fadeOutTime = 250;
    function loaded() {
      var noscript = document.getElementById('noscript-' + imageID);
      var imageHTML = noscript.textContent;
      var tmpContainer = document.createElement('DIV');
      tmpContainer.innerHTML = imageHTML;
      var imageTag = tmpContainer.firstElementChild;
      var parentNode = imagePlaceholder.parentNode;
      imageTag.classList.add('rendering');
      parentNode.insertBefore(imageTag, imagePlaceholder);
      setTimeout(function() {
        var style = document.getElementById('style-' + imageID);
        imageTag.classList.remove('rendering');
        parentNode.removeChild(noscript);
        parentNode.removeChild(imagePlaceholder);
        parentNode.removeChild(style);
      }, fadeOutTime);
    }
    image.onerror = image.onload = function() {
      var endTime = new Date().getTime();
      if (endTime - startTime < minimumTimeToLoad) {
        setTimeout(loaded, minimumTimeToLoad - (endTime - startTime));
        return;
      }
      loaded();
    };
    image.src = imageSrc;
  }
  var checkOnImagesForLoading = throttle.call(function() {
    var imagePlaceholders = document.querySelectorAll('.image-placeholder.never-loaded');
    if (!imagePlaceholders.length) {
      document.removeEventListener('scroll', checkOnImagesForLoading);
    }
    [].map.call(imagePlaceholders, function(imagePlaceholder) {
      if (isScrolledIntoView(imagePlaceholder)) {
        imagePlaceholder.classList.remove('never-loaded');
        fadeInImageFromPlaceholder(imagePlaceholder);
      }
    });
  }, 100);
  checkOnImagesForLoading();
  document.addEventListener('scroll', checkOnImagesForLoading);
})(document, window);
